import { graphql } from "@opensea/graphql"

export const convertItemsAndPricingToListingsFragment = graphql(`
  fragment convertItemsAndPricingToListings on Item {
    id
    name
    tokenId
    contractAddress
    chain {
      identifier
      listingCurrency {
        address
        symbol
      }
    }
    collection {
      id
      fees {
        openseaFee {
          feeBasisPoints
          isRequired
        }
      }
    }
  }
`)
